import { useMemo } from 'react';
import type { AttributeOption, SensorAlertBundle } from '@mark43/cad-api';
import { useBootstrapState } from '../bootstrap/bootstrap-provider';
import { formatSensorPriority, isSensorPriority1 } from './helpers';

// Module-level, so a bootstrap without options does not defeat the memo below.
const NO_PRIORITY_OPTIONS: AttributeOption[] = [];

/**
 * An alert's priority for display: its short label, and whether it is Priority 1 — the one level
 * CAD colours anywhere, as the event queue does. Read against the bootstrap's priority options,
 * the same ones the event form offers, so this costs no request.
 */
export function useSensorPriority(alert: Pick<SensorAlertBundle, 'sensorPriority'> | undefined): {
    label: string | undefined;
    isPriority1: boolean;
} {
    const { eventPanelOptions } = useBootstrapState();
    const priorityOptions = eventPanelOptions?.priorityOptions ?? NO_PRIORITY_OPTIONS;
    const sensorPriority = alert?.sensorPriority;

    return useMemo(
        () => ({
            label: formatSensorPriority(sensorPriority),
            isPriority1: isSensorPriority1(sensorPriority, priorityOptions),
        }),
        [sensorPriority, priorityOptions]
    );
}
